import React, { useState, useCallback, ReactNode } from 'react'
import Toast from '../components/Toast'

type ToastData = {
  id: string
  message: string
  duration: number
  onDismiss: () => void
}

type UseToastReturnType = [(message: string, duration?: number) => void, ReactNode | null]

const useToast = (): UseToastReturnType => {
  const [toast, setToast] = useState<ToastData | null>(null)

  const showToast = useCallback((message: string, duration = 3000): void => {
    const id = Math.random().toString(36).substring(2)
    const onDismiss = () => {
      setToast((currentToast) => (currentToast && currentToast.id === id ? null : currentToast))
    }
    setToast({ id, message, duration, onDismiss })
  }, [])

  const toastMarkup: ReactNode | null = toast ? (
    <Toast key={toast.id} message={toast.message} duration={toast.duration} onDismiss={toast.onDismiss} />
  ) : null

  return [showToast, toastMarkup]
}

export default useToast
